module.exports = __webpack_public_path__ + "img/yes.b8c81289.png";